<template>
  <Head title="Integrations - Data Set Mapping" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <mapping :client="client" :files="files" :dataset="dataset" :source_types="source_types"></mapping>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  files: {
    type: Array,
    default: null
  },
  dataset: Object,
  source_types: Object
});
</script>

